<div
    *transloco="let t"
    class="bazis-range__wrapper"
    [style.--min]="min()"
    [style.--max]="max()"
    [style.--value]="dualThumbs() && values ? '' : styles().value ? styles().value : range.value"
    [style.--value-from]="
        dualThumbs() && values ? (styles().valueFrom ? styles().valueFrom : values().from) : ''
    "
    [style.--value-to]="
        dualThumbs() && values() ? (styles().valueTo ? styles().valueTo : values().to) : ''
    "
>
    <div
        class="bazis-range__track"
        part="track"
    ></div>
    <div
        class="bazis-range__progress"
        [class.bazis-range__progress_interval]="dualThumbs() && values()"
        part="progress"
    ></div>
    <div class="bazis-range__thumbs">
        @if (pin()) {
            <span
                class="bazis-range__pin"
                [class.bazis-range__pin_from]="dualThumbs() && values()"
                part="pin"
            >
                {{ range.value }} {{ pinDimension() }}
            </span>
        }

        @if (customPinTemplate) {
            <ng-container
                [ngTemplateOutlet]="customPinTemplate"
                [ngTemplateOutletContext]="{
                    $implicit: '',
                    value: range.value,
                }"
            >
            </ng-container>
        }

        <input
            #range
            part="range"
            type="range"
            class="bazis-range__input bazis-range__input_from"
            [attr.min]="min()"
            [attr.max]="max()"
            [attr.step]="step()"
            [attr.disabled]="disabled() ? '' : null"
            [formControl]="fromControl"
        />

        @if (dualThumbs() && values()) {
            @if (pin()) {
                <span
                    class="bazis-range__pin bazis-range__pin_to"
                    part="pin"
                >
                    {{ rangeSecond.value }} {{ pinDimension() }}
                </span>
            }

            @if (customPinTemplate) {
                <ng-container
                    [ngTemplateOutlet]="customPinTemplate"
                    [ngTemplateOutletContext]="{
                        $implicit: '',
                        value: rangeSecond.value,
                    }"
                >
                </ng-container>
            }
            <input
                #rangeSecond
                part="range"
                type="range"
                class="bazis-range__input bazis-range__input_to"
                [attr.min]="min()"
                [attr.max]="max()"
                [attr.step]="step()"
                [attr.disabled]="disabled() ? '' : null"
                [formControl]="toControl"
            />
        }
    </div>

    @if (showScale()) {
        <div
            class="bazis-range__scale"
            part="scale"
        >
            @for (i of scale; track i) {
                <div class="bazis-range__scale__label">
                    {{ i }}
                </div>
            }
        </div>
    }
</div>

@let updFormValues = updFormValues$ | async;
@let changeFrom = changeFrom$ | async;
@let changeTo = changeTo$ | async;
